import React from "react";
import { FlagRecord } from "./flags";

const FeatureFlagContext = React.createContext<FlagRecord>({});

export default FeatureFlagContext;
